import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type PhysicianSpecialty = ApiSchemas['PhysicianSpecialtyPresenter']

export type SpecialtyType = ApiSchemas['SpecialtyTypePresenter']

export default {
  async list(options?: ApiSchemas['ListSpecialtyTypeDto']) {
    return wrapEndpoint(() =>
      client.GET('/specialty-type', {
        params: {
          query: options,
        },
      }),
    )
  },
}
